module.exports = __webpack_public_path__ + "img/reset-password1.ebcde4aa.jpg";